export function useToMap<T>(items: T[], key: string = "id"): Map<string, T>
{
    const result = new Map<string, T>();
    for (let item of items)
    {
        result.set(`${(item as { [key: string]: string })?.[key]}`, item);
    }
    return result;
}